import { TextInput, View, type TextInputProps } from 'react-native';

import { AppText } from '@/components/ui/app-text';
import { colors, fonts, radius, spacing } from '@/theme/tokens';

interface TextFieldProps extends TextInputProps {
  label?: string;
}

/** Labeled input styled like the Stitch mock fields (white pill on light bg) */
export function TextField({ label, style, ...rest }: TextFieldProps) {
  return (
    <View style={{ gap: spacing.base }}>
      {label ? <AppText variant="labelLg" color={colors.navy}>{label}</AppText> : null}
      <TextInput
        placeholderTextColor={colors.outlineVariant}
        {...rest}
        style={[
          {
            backgroundColor: colors.card,
            // Visible outline: fields sit on cards with the SAME background, so
            // without a border there was nothing to tap-target visually (the
            // president couldn't find the name fields on the help form, 2026-07-18).
            borderWidth: 1.5,
            borderColor: colors.outlineVariant,
            borderRadius: radius.button,
            paddingHorizontal: spacing.md,
            paddingVertical: spacing.sm,
            minHeight: 52,
            fontFamily: fonts.semiBold,
            fontSize: 18,
            color: colors.textPrimary,
          },
          style,
        ]}
      />
    </View>
  );
}
